(function() {
    const env = process.env.NODE_ENV
    const domain = env == 'development' ? 'localhost' : env == 'production' ? '.anycmp.com' : '.anycmp.com'
    var _cookie = {
        set: function(objName, objValue, objHours) {
            var str = objName + "=" + escape(objValue);
            if (objHours > 0) { //为0时不设定过期时间，浏览器关闭时cookie自动消失  
                var date = new Date();
                date.setTime(objHours*1000);
                str += "; expires=" + date.toUTCString() + ";domain=" +domain + ";path=/";
            }
            document.cookie = str;
        },
        get: function(objName) {
            var arrStr = document.cookie.split("; ");
            for (var i = 0; i < arrStr.length; i++) {
                var temp = arrStr[i].split("=");
                if (temp[0] == objName) return unescape(temp[1]);
            }
        },
        del: function(objName) {
            var exp = new Date();
            exp.setTime(exp.getTime() - 1);
            document.cookie = objName + "="  + ";expires=" + exp.toUTCString() + ";domain=" +domain + ";path=/";
        }
    }


    window.COOKIE = _cookie;

})();



// WEBPACK FOOTER //
// ./src/utils/cookie.js